module.exports = __webpack_public_path__ + "static/media/handwash-and-sanitizer.d73c4d5e.jpg";